import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTipoPrecioTxComponent } from "./edit-tipo-precio-tx/edit-tipo-precio-tx.component";

@Component({
  selector: "app-tipo-precio-tx",
  templateUrl: "./tipo-precio-tx.component.html",
  styleUrls: ["./tipo-precio-tx.component.scss"],
})
export class TipoPrecioTxComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditTipoPrecioTxComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
